import styled from 'styled-components';
import { 
  // COLOR, FONT 
} from 'assets';

export const TrueWalletStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
`;
